import SavedSearchConstants from '../constants/SavedSearchConstants';
import SavedSearchApi from '../api/SavedSearchApi';

import composeGlobalSuccessMessaging from '../helpers/messaging/composeGlobalSuccessMessaging';

function removeUnneededEntryFromQuery(query) {
  const changedQuery = query.replace(/&_ga=[^&]+/g, '');
  return changedQuery.replace(/title=[^&]+/g, '');
}

export function saveSearch({ name, query, postSuccess }) {
  return {
    postSuccess,
    types: [SavedSearchConstants.SAVE_REQUEST, SavedSearchConstants.SAVE_SUCCESS, SavedSearchConstants.SAVE_FAILURE],
    payload: { name },
    apiRequest: (state, apiClient) => SavedSearchApi.saveSearch(name, removeUnneededEntryFromQuery(query), apiClient),
    apiSuccess: () => ({
      messaging: composeGlobalSuccessMessaging('saved_search_success', { values: { search_name: name } })
    }),
    apiFailure: () => ({
      messaging: null
    })
  };
}

export function replaceSearch({ query, name, postSuccess }) {
  return {
    postSuccess,
    types: [
      SavedSearchConstants.REPLACE_SAVE_SEARCH_REQUEST,
      SavedSearchConstants.REPLACE_SAVE_SEARCH_SUCCESS,
      SavedSearchConstants.REPLACE_SAVE_SEARCH_FAILURE
    ],
    apiRequest: (state, apiClient) =>
      SavedSearchApi.replaceSearch(
        state.getIn(['ui', 'savedSearch', 'lastNameAttempt']),
        removeUnneededEntryFromQuery(query),
        state.getIn(['ui', 'savedSearch', 'duplicateSearchId']),
        apiClient
      ),
    apiSuccess: () => ({
      messaging: composeGlobalSuccessMessaging('saved_search_success', { values: { search_name: name } })
    })
  };
}

export function chooseNewName() {
  return {
    type: SavedSearchConstants.CHOOSE_NEW_NAME
  };
}

export default {
  saveSearch,
  replaceSearch,
  chooseNewName
};
